export enum EnumVotumErgebnisStop{
  ABLEHNEN = 'Ablehnen'
}
